var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInUp", delay: 0, duration: 300 },
          expression: "{ classes: 'slideInUp', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "chatbot-agent",
    },
    [
      _c("section", { staticClass: "header" }, [
        _c("span", { staticClass: "d-flex align-items-center gap-5" }, [
          _c("img", {
            attrs: {
              src: "/static/img/copilot.png",
              width: "32",
              height: "32",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column" }, [
            _c(
              "strong",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "font-size": "18px", "letter-spacing": "1px" },
              },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.supsisAssistant")))]
            ),
            _vm._v(" "),
            _c(
              "small",
              {
                class:
                  _vm.connectionStatus === "connected"
                    ? "text-success"
                    : "text-warning",
              },
              [
                _c("a-badge", {
                  attrs: {
                    color:
                      _vm.connectionStatus === "connected" ? "green" : "orange",
                  },
                }),
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.connectionStatus === "connected"
                        ? _vm.$t("chatbotv2.chatbotExpert")
                        : _vm.$t("chatbotv2.connecting")
                    ) +
                    "\n                "
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "md-button",
              { staticClass: "md-icon-button", on: { click: _vm.handleClose } },
              [_c("md-icon", [_vm._v("close")])],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "chat-conversation" }, [
        _c("div", { staticClass: "conversation" }, [
          _c(
            "div",
            { ref: "messagesContainer", staticClass: "chat-messages" },
            [
              !_vm.messages.length
                ? _c("div", { staticClass: "welcome-message" }, [
                    _c("div", { staticClass: "welcome-content" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/img/copilot.png",
                          width: "48",
                          height: "48",
                        },
                      }),
                      _vm._v(" "),
                      _c("h4", [
                        _vm._v(
                          _vm._s(_vm.$t("chatbotv2.chatbotAssistantWelcome"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.howCanIHelpChatbot"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "quick-actions" }, [
                        _c(
                          "div",
                          {
                            staticClass: "quick-action",
                            on: {
                              click: function ($event) {
                                return _vm.sendQuickMessage(
                                  "Yeni bir karşılama botu yapmak istiyorum"
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add_circle"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.createNewBot"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "quick-action",
                            on: {
                              click: function ($event) {
                                return _vm.sendQuickMessage(
                                  "Mevcut botumu optimize etmek istiyorum"
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("tune"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.optimizeBot"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "quick-action",
                            on: {
                              click: function ($event) {
                                return _vm.sendQuickMessage(
                                  "Botuma AI özelliği eklemek istiyorum"
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("psychology"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.addAiFeature"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.messages, function (message) {
                return _c(
                  "div",
                  { key: message.id, class: ["message", message.type] },
                  [
                    message.type === "user"
                      ? _c("div", { staticClass: "user-message" }, [
                          _c("div", { staticClass: "message-content" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(message.content) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "message-time" }, [
                            _vm._v(_vm._s(_vm.formatTime(message.timestamp))),
                          ]),
                        ])
                      : message.type === "agent"
                      ? _c("div", { staticClass: "agent-message" }, [
                          _vm._m(0, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "message-bubble modern" }, [
                            _c("div", {
                              staticClass: "message-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatMessage(message.content)
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "message-time" }, [
                              _vm._v(_vm._s(_vm.formatTime(message.timestamp))),
                            ]),
                          ]),
                        ])
                      : message.type === "system"
                      ? _c("div", { staticClass: "system-message" }, [
                          _c("div", { staticClass: "system-content" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(message.content))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "message-time" }, [
                            _vm._v(_vm._s(_vm.formatTime(message.timestamp))),
                          ]),
                        ])
                      : message.type === "function"
                      ? _c("div", { staticClass: "function-message" }, [
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "function-bubble" }, [
                            _c("div", { staticClass: "function-header" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("build"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.processingActions"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "function-list" },
                              _vm._l(message.functions, function (func) {
                                return _c(
                                  "div",
                                  {
                                    key: func.id,
                                    staticClass: "function-item",
                                    class: func.status,
                                  },
                                  [
                                    func.status === "pending"
                                      ? _c("a-icon", {
                                          staticStyle: { color: "#1890ff" },
                                          attrs: { type: "loading" },
                                        })
                                      : func.status === "completed"
                                      ? _c("a-icon", {
                                          staticStyle: { color: "#52c41a" },
                                          attrs: {
                                            type: "check-circle",
                                            theme: "filled",
                                          },
                                        })
                                      : func.status === "failed"
                                      ? _c("a-icon", {
                                          staticStyle: { color: "#f5222d" },
                                          attrs: {
                                            type: "close-circle",
                                            theme: "filled",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "function-content" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "function-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getFunctionDisplayName(
                                                  func.name
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        func.summary &&
                                        func.status === "completed"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "function-summary",
                                              },
                                              [_vm._v(_vm._s(func.summary))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        func.error
                                          ? _c(
                                              "span",
                                              { staticClass: "function-error" },
                                              [_vm._v(_vm._s(func.error))]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.isLoading
                ? _c("div", { staticClass: "loading-message" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "footer" }, [
        _c("div", { staticClass: "chat-input" }, [
          _c(
            "div",
            { staticClass: "input-container" },
            [
              _c("a-textarea", {
                ref: "messageInput",
                attrs: {
                  rows: 1,
                  "auto-size": { minRows: 1, maxRows: 3 },
                  placeholder: _vm.$t(
                    "chatbotv2.chatbotAssistantInputPlaceholder"
                  ),
                  disabled: _vm.isLoading,
                },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleEnterKey.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.inputMessage,
                  callback: function ($$v) {
                    _vm.inputMessage = $$v
                  },
                  expression: "inputMessage",
                },
              }),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "send-button",
                  attrs: {
                    type: "primary",
                    disabled: !_vm.inputMessage.trim() || _vm.isLoading,
                  },
                  on: { click: _vm.sendMessage },
                },
                [_c("a-icon", { attrs: { type: "send" } })],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-avatar" }, [
      _c("img", {
        attrs: { src: "/static/img/copilot.png", width: "32", height: "32" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-avatar" }, [
      _c("img", {
        attrs: { src: "/static/img/copilot.png", width: "32", height: "32" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-avatar" }, [
      _c("img", {
        attrs: { src: "/static/img/copilot.png", width: "32", height: "32" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-bubble" }, [
      _c("div", { staticClass: "typing-indicator" }, [
        _c("span"),
        _vm._v(" "),
        _c("span"),
        _vm._v(" "),
        _c("span"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }